"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyOrNotifyMe = void 0;
var _openShadePicker = require("@ori-events/open-shade-picker");
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _internal = require("../../hooks/internal");
var _useQuickBuyButtonTooltipHandlers = require("../../hooks/internal/useQuickBuyButtonTooltipHandlers");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _internal2 = require("../../utils/internal");
var _NotifyMe = require("./NotifyMe");
var _QuantityPicker = require("./QuantityPicker");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BuyOrNotifyMe = () => {
  const {
    addToBasketMethod,
    analyticsData,
    buttons,
    hideSubscription,
    code,
    name,
    price,
    quantityPicker,
    isMultiShade,
    hasAutoSubscription,
    subscription,
    onQuickBuyButtonClick,
    onNotifyMeButtonClick,
    mode
  } = (0, _internal.useProduct)();
  const {
    notifyMe,
    quickBuy: quickBuyButton
  } = buttons ?? {};
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const onQuickBuyClick = onQuickBuyButtonClick ? () => onQuickBuyButtonClick({
    newValue: 1,
    id: code,
    source: 'increase'
  }) : undefined;
  const onQuickBuyClickFallback = (0, _react.useMemo)(() => {
    if (!!hasAutoSubscription || subscription?.available && !hideSubscription) {
      return (0, _internal2.openProductInfoDialog)(code, analyticsData);
    }
    return (0, _internal2.openShadePicker)(code, analyticsData?.placement, _openShadePicker.ShadePickerMode.QuickBuy);
  }, [analyticsData, code, hasAutoSubscription, hideSubscription, subscription?.available]);
  const {
    open,
    onClose,
    onToggle
  } = (0, _presentationHooks.useDisclose)();
  const {
    onQuickBuyButtonClick: onQuickBuyButtonWithTooltipClick
  } = (0, _useQuickBuyButtonTooltipHandlers.useQuickBuyButtonTooltipHandlers)({
    onClose,
    onToggle,
    open
  });
  if (quantityPicker?.visible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_QuantityPicker.QuantityPicker, {});
  }
  if (quickBuyButton?.visible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ClickAwayListener, {
      onClickAway: onClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
        title: quickBuyButton.disabled ? quantityPicker?.tooltipMaxText : null,
        open: open,
        placement: "top",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.QuickBuyButtonWrapper, {
          ...(quickBuyButton.disabled ? {
            role: 'button',
            tabIndex: 0,
            onClick: onQuickBuyButtonWithTooltipClick,
            onKeyDown: onClose
          } : {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.QuickBuyButton, {
            "aria-label": translations.quickBuy,
            currentPrice: price?.currentFormatted ?? '',
            currentProductCode: code,
            disabled: quickBuyButton.disabled,
            name: name,
            addToBasketMethod: addToBasketMethod,
            placement: analyticsData?.placement,
            position: analyticsData?.position,
            size: "medium",
            desktopSize: "large",
            hasAutoSubscription: hasAutoSubscription,
            isMultiShade: mode === _models.ProductBoxMode.Concept ? isMultiShade : false,
            onQuickBuyButtonClick: Boolean(quickBuyButton.trigger) || subscription?.available && !hideSubscription ? onQuickBuyClick ?? onQuickBuyClickFallback : undefined
          })
        })
      })
    });
  }
  if (notifyMe?.visible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotifyMe.NotifyMe, {
      code: code,
      disabled: notifyMe.disabled,
      onNotifyMeButtonClick: notifyMe.trigger ? onNotifyMeButtonClick ?? (0, _internal2.openShadePicker)(code, analyticsData?.placement, _openShadePicker.ShadePickerMode.QuickBuy) : undefined
    });
  }
  return null;
};
exports.BuyOrNotifyMe = BuyOrNotifyMe;
